import { AWARD_TYPES, CATEGORIES, CONTENT_TYPES, VISIBILITY_GROUPS, DURATIONS, LANGUAGES, LEVELS, SORT_BYS, ASSIGNED_BY, TOOLS, CREATED_BY, SORT_BY_MY_PLAYLISTS, PROGRESS_STATUS } from '../../constants/TopFilterConstants';
import { MY_PLAYLISTS_TABS } from '../myPlaylists/myPlaylistsTypes';

// Link each filter query key with possible values from consts
export const FilterItems = {
  awardType: AWARD_TYPES,
  cat: CATEGORIES,
  contentType: CONTENT_TYPES,
  contentSource: VISIBILITY_GROUPS,
  createdBy: CREATED_BY,
  duration: DURATIONS,
  language: LANGUAGES,
  level: LEVELS,
  sortBy: SORT_BYS,
  tools: TOOLS,
  assignedBy: ASSIGNED_BY,
  search: [],
  searchUser: [],
  searchAccounts: [],
  myPlaylistsType: MY_PLAYLISTS_TABS,
  sortByMyPlaylists: SORT_BY_MY_PLAYLISTS,
  progressStatus: PROGRESS_STATUS,
  assignment: ['ASSIGNED', 'NOT_ASSIGNED']
};